import type { LocaleObject } from '@nuxtjs/i18n'

export function getLocaleCode(code: LocaleObject['code']): string {
  const [, localeCode] = code.split('-')

  return localeCode
}
